/* eslint-disable react/display-name,react/prop-types */
import React from "react"
import { Box, Tab, Tabs } from "@material-ui/core"
import { useHistory } from "react-router-dom"
import _ from "lodash"
import useSmartFormat from "../../i18n/useSmartFormat"

/**
 * Default impl to search path in sub menu by location
 * @param history
 * @return {function(*): boolean}
 */
export const findByLocation = (history) => (path) => {
  return history.location.pathname === path.location
}

/**
 *
 * @param Wrapper React component's function
 * @param menus a table defines all sub menu
 * @param search (optional) provide a search index method, default try to search by location
 * @param getPlaceholders (optional) provides an object to be used with format() for the tab title
 * @return a function that render wrapper adding sub tab menu mechanism
 */
export default function withTabMenu(
  Wrapper,
  menus,
  search = findByLocation,
  getPlaceholders = () => {},
  showFileAriane = true
) {
  return (props) => {
    const { children } = props
    const format = useSmartFormat()
    const history = useHistory()

    let menuIdx = menus.findIndex(search(history))
    if (menuIdx === -1 && !_.isEmpty(menus)) {
      // it is the default behaviour of Tabs, when wrong value is given
      // and it removes props validation failed warning
      menuIdx = 0
    }

    const redirectTo = (evt, tabIdx) => history.push(menus[tabIdx].location)

    return (
      <Wrapper {...props}>
        <Box display="flex" alignItems="center">
          <Box display="flex" flex={1}>
            {showFileAriane ? children : ""}
          </Box>
          <Box>
            <Tabs value={menuIdx} onChange={redirectTo} className="inner-tabs">
              {menus.map((menu) => (
                <Tab
                  key={menu.title?.id || menu.title}
                  label={format(menu.title, getPlaceholders())}
                  aria-controls="user-tab"
                  className="inner-tab"
                />
              ))}
            </Tabs>
          </Box>
          <Box display="flex" flex={1} justifyContent="flex-end" />
        </Box>
      </Wrapper>
    )
  }
}
